// Returns the set of ChecklistCategories value ids that belong to the system-managed
// "Processes" category, i.e. the checklists that are used inside a Process.
export default function findProcessesCategoryValueIds(checklistCategories: ObjectStringKeyAnyValue | null): Set<string> {
  const processesCategory = Object.values(checklistCategories || {}).find(
    (category: any) => category?.ManagedBySystem === 'processes'
  ) as ObjectStringKeyAnyValue | undefined

  return new Set(Object.keys(processesCategory?.Values || {}))
}
